import type { Modules } from '@lotta/shared/types-lottery-schemas';
import { module as claimMyPrizeModule } from './claim-my-prize/ClaimMyPrizeForm';
import { module as emailModule } from './email/EmailForm';
import { module as generalModule } from './general/GeneralForm';
import { module as maxWinnersPerStoreModule } from './max-winners-per-store/MaxWinnersPerStoreForm';
import { module as monthlyOccurrenceModule } from './monthly-occurrence/MonthlyOccurrenceForm';
import { module as purchaseModule } from './purchase/PurchaseForm';
import { module as simpleSignupModule } from './simple-signup/SimpleSignupForm';
import { module as singleOccurrenceModule } from './single-occurrence/SingleOccurrenceForm';
import { module as swipeModule } from './swipe/SwipeForm';
import { module as weeklyOccurrenceModule } from './weekly-occurrence/WeeklyOccurrenceForm';
import { module as winnersModule } from './winners/WinnersForm';
import { module as legalModule } from './legal/LegalForm';
import { module as emailSubscriptionModule } from './email-subscription/EmailSubscription';
import { module as noCommunicationModule } from './no-communication/NoCommunicationForm';
import { module as emailMarketingConstraint } from './email-marketing-constraint/EmailMarketingConstraintForm';
import { module as minimumPurchaseAmountModule } from './minimum-purchase-amount/MinimumPurhcaseAmountForm';

export const moduleMap = {
  [claimMyPrizeModule.name]: claimMyPrizeModule,
  [emailModule.name]: emailModule,
  [generalModule.name]: generalModule,
  [maxWinnersPerStoreModule.name]: maxWinnersPerStoreModule,
  [emailMarketingConstraint.name]: emailMarketingConstraint,
  [monthlyOccurrenceModule.name]: monthlyOccurrenceModule,
  [purchaseModule.name]: purchaseModule,
  [simpleSignupModule.name]: simpleSignupModule,
  [singleOccurrenceModule.name]: singleOccurrenceModule,
  [swipeModule.name]: swipeModule,
  [weeklyOccurrenceModule.name]: weeklyOccurrenceModule,
  [winnersModule.name]: winnersModule,
  [legalModule.name]: legalModule,
  [emailSubscriptionModule.name]: emailSubscriptionModule,
  [noCommunicationModule.name]: noCommunicationModule,
  [minimumPurchaseAmountModule.name]: minimumPurchaseAmountModule,
} satisfies Record<Modules, unknown>;

export type ModuleName = keyof typeof moduleMap;

export const getModuleForm = <T extends ModuleName>(
  moduleName: T
): (typeof moduleMap)[T]['form'] => {
  return moduleMap[moduleName].form;
};
